import { FiUploadCloud } from "react-icons/fi";
import { useState } from "react";
import "../styles.css";
import ImagePicker from "../../../component/image-picker";
import { LuMinus } from "react-icons/lu";

function ImageUploader(props: any) {
  const [isloading, setIsloading] = useState(false);
  const [imageUrl, setImageUrl] = useState(props.imageUrl);
  const [imageUploader, setImageUploader] = useState(false);
  const [imgError, setImgError] = useState(false);

  const addImage = (val: any) => {
    const url =
      typeof val.image_url === "string"
        ? val.image_url
        : val.image_url?.imageUrl || val.image_url?.url || "";
    setImageUrl(url);
    setImgError(false);
    props.setImage(url);
  };

  const removeImage = () => {
    setImageUrl(null);
    setImgError(false);
    props.removeImage();
  }

  return (
    <section className="addScreen-ImageUploaderBox1">
      {imageUrl && !imgError ? (
        <div style={{ position: "relative", width: "100%", textAlign: "center" }}>
          <LuMinus
            size={25}
            onClick={() => removeImage()}
            className="image-delete-btn"
          />
          <img
            src={imageUrl}
            className="addScreen-ImageUploaderImg1"
            alt={`${props.type} Banner`}
            onError={() => setImgError(true)}
          />
        </div>
      ) : (
        <div
          className="addScreen-ImageUploaderBox2"
          onClick={() => setImageUploader(true)}
        >
          {isloading ? <div>Loading . . .</div> : <FiUploadCloud size={30} />}
          <div>Upload {props.type} Banner</div>
        </div>
      )}
      {imageUploader ? (
        <ImagePicker
          mode="create"
          imageName="Ad"
          imageType={props.type}
          onSubmit={(val: any) => addImage(val)}
          visible={imageUploader}
          close={() => setImageUploader(false)}
        />
      ) : null}
    </section>
  );
}

export default ImageUploader;
